<script>
export default {
  computed: {
    filteredCenters() {
      if (!this.searchFields.products || !this.searchOptions.centers) {
        return this.searchOptions.centers;
      }
      return this.searchOptions.centers.filter((center) =>
        center.product_ids.includes(this.searchFields.products),
      );
    },
  },
  watch: {
    filteredCenters(newCenters) {
      const validIds = newCenters.map((c) => c.id);
      const current = Array.isArray(this.searchFields.center)
        ? this.searchFields.center
        : [];
      this.searchFields.center = current.filter((id) => validIds.includes(id));
    },
  },
};
</script>
